import React, { useState, useEffect, useContext, Component, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import axios from 'axios';
import { useDispatch } from 'react-redux';
import { authActions } from '../../redux/store';
import { toast } from 'react-hot-toast';
import Header from '../components/Header';
import Footer from '../components/Footer';
import axiosInstance, { keyLogin } from '../../axiosInstance';
import setCookie from '../../helper/setCookie';
import getCookie from '../../helper/getCookie';
import { encrypt } from '../../helper/encryption';
import LoginComponents from '../components/LoginComponents';
import PropTypes from 'prop-types';
import NavBar from '../components/NavBar';
import HeaderPage from '../components/HeaderPage';

function UserLogin({ updateAuthStatus }) {
  return (
    <>
 
      <Helmet>
        <title>User Login | {window.location.hostname}</title>
      </Helmet>

  <HeaderPage title={'Login/Signup'} />
 

<main className="page-content  space-top dz-gradient-shape bg-light  "> 
 <div className='p-4  w-100  '>
 <div className="p-3 border rounded bg-white ">
     <LoginComponents updateAuth={updateAuthStatus} />
  </div>

  </div>
 

</main>


      <NavBar />
    </>
  );
}

// ✅ FIXED: updateAuthStatus is a function, not a boolean
UserLogin.propTypes = {
  updateAuthStatus: PropTypes.func.isRequired,
};

// ✅ Optional: improve performance with memo
export default React.memo(UserLogin);
